import React from 'react';
import { 
  Box, 
  Grid, 
  Card, 
  CardContent, 
  Typography, 
  Button,
  IconButton 
} from '@mui/material';
import { 
  Description as Form990Icon,
  History as HistoryIcon,
  Download as DownloadIcon,
  Refresh as RefreshIcon 
} from '@mui/icons-material';
import { Form990Generator } from './Form990';
import { useForm990History } from './Form990/hooks/useForm990History';

export const ReportsDashboard: React.FC = () => {
  const [showForm990Generator, setShowForm990Generator] = React.useState(false);

  // Track recent 990 submissions
  const { history: recent990s, downloadPDF, refreshHistory } = useForm990History();

  if (showForm990Generator) {
    return <Form990Generator onClose={() => setShowForm990Generator(false)} />;
  }

  return (
    <Box>
      <Grid container spacing={3}>
        {/* Form 990 Quick Access Card */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Form 990
              </Typography>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="body2" color="text.secondary">
                  Last filed: {recent990s[0]?.submittedDate || 'Not filed yet'}
                </Typography>
                <Button
                  variant="contained"
                  startIcon={<Form990Icon />}
                  onClick={() => setShowForm990Generator(true)}
                >
                  Generate New 990
                </Button>
              </Box>
              
              {/* Recent 990 History */}
              {recent990s.length > 0 && (
                <Box mt={2}>
                  <Typography variant="subtitle2" gutterBottom>
                    Recent Submissions
                  </Typography>
                  {recent990s.map(form => (
                    <Box 
                      key={form.id}
                      display="flex" 
                      justifyContent="space-between"
                      alignItems="center"
                      py={1}
                    >
                      <Typography variant="body2">
                        Tax Year {form.taxYear}
                      </Typography>
                      <Box>
                        <IconButton 
                          size="small"
                          onClick={() => downloadPDF(form.id)}
                        >
                          <DownloadIcon />
                        </IconButton>
                        <IconButton 
                          size="small"
                          onClick={() => refreshHistory()}
                        >
                          <RefreshIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}; 